import { render, staticRenderFns } from "./Filter.vue?vue&type=template&id=06c0d134&scoped=true&"
import script from "./Filter.vue?vue&type=script&lang=ts&"
export * from "./Filter.vue?vue&type=script&lang=ts&"
import style0 from "./Filter.vue?vue&type=style&index=0&id=06c0d134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c0d134",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VChip,VChipGroup,VDialog,VImg})
